// import daylogo from "../assets/DAYLogo.jpg";

function Footer() {
	return (
		<div id='footing' className="container">
            <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-0">
                <span>© 2026 Dear Asian Youth, USC</span>
            </footer>
        </div>
	);
}

export default Footer; 